var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcForward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.293 3.293a1 1 0 0 1 1.414 0L14.414 7l-3.707 3.707a1 1 0 0 1-1.414-1.414L10.586 8H8a4 4 0 0 0-3.877 3.01c-.136.535-.57.99-1.123.99-.552 0-1.009-.451-.918-.996A6 6 0 0 1 8 6h2.586L9.293 4.707a1 1 0 0 1 0-1.414",
  clipRule: "evenodd"
})));
export default SvgIcForward;